import { TagListResponse } from '../types/contact';
import { buildUrl, getData } from './api';

export const tagApi = {
  getUserTags(search?: string): Promise<TagListResponse> {
    return getData<TagListResponse>(buildUrl('/api/tags', { search }));
  },
};

export default tagApi;
